import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.00195 19V17H6.00195V10C6.00195 8.61667 6.41862 7.38733 7.25195 6.312C8.08529 5.23733 9.16862 4.53333 10.502 4.2V3.5C10.502 3.08333 10.648 2.72933 10.94 2.438C11.2313 2.146 11.5853 2 12.002 2C12.4186 2 12.7726 2.146 13.064 2.438C13.356 2.72933 13.502 3.08333 13.502 3.5V4.2C14.8353 4.53333 15.9186 5.23733 16.752 6.312C17.5853 7.38733 18.002 8.61667 18.002 10V17H20.002V19H4.00195ZM12.002 22C11.452 22 10.9813 21.8043 10.59 21.413C10.198 21.021 10.002 20.55 10.002 20H14.002C14.002 20.55 13.8063 21.021 13.415 21.413C13.023 21.8043 12.552 22 12.002 22ZM8.00195 17H16.002V10C16.002 8.9 15.6103 7.95833 14.827 7.175C14.0436 6.39167 13.102 6 12.002 6C10.902 6 9.96029 6.39167 9.17695 7.175C8.39362 7.95833 8.00195 8.9 8.00195 10V17Z"
      fill={props?.fill || '#373C49'}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const IconBadge = memo(ForwardRef);
export default IconBadge;
